import type { LaunchDarklyFlags } from '@/common/launchDarkly';
import type { IntegrationsResponse } from './integrations/types';

type UseSellersShieldBannerArgs = {
  flags?: LaunchDarklyFlags;
  integrations?: IntegrationsResponse;
  showSellersShieldBanner?: boolean;
  isFromFilesUi?: boolean;
};

export function useSellersShieldBanner(args: UseSellersShieldBannerArgs) {
  const { flags, integrations, showSellersShieldBanner, isFromFilesUi = false } = args;

  // User is opted in and not in forced flow (broker required)
  const userOptedIn =
    integrations?.sellersshield?.userEnablement === 'active' && !integrations?.sellersshield?.brokerRequired;

  const featureFlagEnabled = Boolean(flags?.sellersShieldEnvelopeSentBanner);

  // Show banner if:
  // 1. Feature flag is enabled AND user is opted in
  // 2. AND either:
  //    a) Coming from files-ui: respect the showSellersShieldBanner parameter (file-level tracking)
  //    b) Standalone DS3: always show for opted-in users (no file tracking)
  const shouldShowBanner =
    featureFlagEnabled && userOptedIn && (isFromFilesUi ? showSellersShieldBanner === true : true);

  return {
    shouldShowBanner,
  };
}
